export default {
  state: {
    projects: [],
    scenes: [],
    test: [],
    selectedProject: null,
  },
  getters: {
    getProjects: (state) => state.projects,
    getSelectedProject: (state) => state.selectedProject,
    getScenes: (state) => state.scenes,
  },
  mutations: {
    setProjects(state, payload) {
      state.projects = payload;
    },
    setScenes(state, payload) {
      state.scenes = payload;
    },
    setSelectedProject(state, payload) {
      state.selectedProject = payload;
    },
    saveLocalScene(state, payload) {
      state.selectedScene = {
        ...state.selectedScene,
        unsaved: true,
      };
    },
  },
};
